module.exports = __webpack_public_path__ + "static/media/logLiquidRemainingActive.932cb17a.svg";